const searchData = [

  // HOME PAGE SECTIONS
  {
    title: "Home — Mission",
    path: "/",
    content: `
      Secure the Digital Future with Echelon.
      Cybersecurity nonprofit promoting digital safety, awareness,
      ethical tech practices, and community protection.
    `
  },
  {
    title: "Home — Volunteer Opportunities",
    path: "/",
    content: `
      Become a volunteer, earn hours, gain hands-on cybersecurity experience,
      protect vulnerable groups, build your resume, and grow your network.
    `
  },
  {
    title: "Home — Highlights",
    path: "/",
    content: `
      Hands-on Experience: quizzes and meetings.
      Community Impact: cybersecurity outreach.
      Career Development: resume building and networking.
    `
  },
  {
    title: "Home — Testimonials",
    path: "/",
    content: `
      Volunteers share how Echelon helped them start cybersecurity careers,
      gain confidence, and make real community impact.
    `
  },

  // GET CERTIFIED
  {
    title: "Get Certified — Overview",
    path: "/GetCertified",
    content: `
      Courses, tests, certification requirements.
      Learn cybersecurity fundamentals and earn your Echelon certification.
    `
  },

  // DASHBOARD PAGE — BROKEN INTO MODULES
  {
    title: "Dashboard — Intro to Cybersecurity",
    path: "/VolunteerHours",
    content: `
      Cyber basics, why cybersecurity matters, digital threats,
      importance of protecting data online.
    `
  },
  {
    title: "Dashboard — Digital Safety",
    path: "/VolunteerHours",
    content: `
      Staying safe online, privacy, avoiding scams, safe browsing,
      protecting personal information.
    `
  },
  {
    title: "Dashboard — Passwords & Authentication",
    path: "/VolunteerHours",
    content: `
      Strong passwords, two-factor authentication, login security,
      preventing password attacks.
    `
  },
  {
    title: "Dashboard — Social Engineering",
    path: "/VolunteerHours",
    content: `
      Phishing, manipulation, scams, attacker psychology,
      how to avoid social engineering threats.
    `
  },
  {
    title: "Dashboard — Malware",
    path: "/VolunteerHours",
    content: `
      Viruses, worms, trojans, spyware, how malware spreads,
      protecting your devices.
    `
  },
  {
    title: "Dashboard — Cyber Ethics",
    path: "/VolunteerHours",
    content: `
      Ethical online behavior, responsible technology use,
      avoiding cybercrime, digital citizenship.
    `
  },
  {
    title: "Dashboard — Quizzes & Progress",
    path: "/VolunteerHours",
    content: `
      Start quizzes, score 70% or higher, unlock modules,
      earn volunteer hours, track progress.
    `
  },
  {
    title: "Dashboard — Final Exam",
    path: "/VolunteerHours",
    content: `
      Unlocks after all modules are completed.
      Awards major volunteer hours and grants certification.
    `
  },

  // CONTACT US — SEPARATED SECTIONS
  {
    title: "Contact Us — Overview",
    path: "/ContactUs",
    content: `
      Contact Echelon for support, collaboration, or joining the program.
      Communication and outreach information.
    `
  },
  {
    title: "Contact Us — Social Links",
    path: "/ContactUs",
    content: `
      Email: secureechelon@gmail.com
      Instagram: Echelon Charlotte
      LinkedIn: Echelon Charlotte
    `
  },
  {
    title: "Contact Us — Team Members",
    path: "/ContactUs",
    content: `
      Jeremiah Kim, Shankar Gopaluni, Anish Subramanian,
      Rampranav Maremanda, Sahith Chappidi,
      Shourvik Santi, Ishaan Joshy.
    `
  },

  // PROFILE PAGE
  {
    title: "Profile — Overview",
    path: "/Profile",
    content: `
      User profile settings, certificates, badges, volunteer hour logs,
      completed modules, personal information.
    `
  }

];

export default searchData;
